<div class="comparison-toast">
  @if (product$ | async; as currentProduct) {
    <div class="comparison-toast__card">
      <div class="comparison-toast__media">
        <sd-media
          class="comparison-toast__image"
          [container]="currentProduct.images?.PRIMARY"
          [alt]="currentProduct.name || 'Товар из сравнения'"
          [loading]="'lazy'"
        ></sd-media>
      </div>
      <div class="comparison-toast__content">
        <div class="comparison-toast__heading">
          <sd-icon [type]="iconTypes.COMPARISON" class="comparison-toast__icon"></sd-icon>
          <p class="comparison-toast__title">добавлено в сравнение</p>
        </div>
        <p class="comparison-toast__product-name">
          {{ currentProduct.name || 'Товар успешно сохранён' }}
        </p>
      </div>
    </div>
  }
</div>
